import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { MigrationModeService } from '../../services/migration-mode.service';

@Injectable({
  providedIn: 'root'
})
export class ModernModeGuard implements CanActivate {
  constructor(
    private migrationModeService: MigrationModeService,
    private router: Router
  ) {}

  canActivate(): boolean | UrlTree {
    if (this.migrationModeService.getCurrentMode() === 'modern') {
      return true;
    }
    return this.router.createUrlTree(['/dashboard']);
  }
}
